import { register, getPrefix } from '../../../Utils'

const CorporateYoutubeVideo = (el, consentPreview) => {
  const prefix = getPrefix(el)
  const videoId = el.dataset.videoid
  const videoContainer = el.querySelector(`.${prefix}video-container`)
  const overlay = el.querySelector(`.${prefix}overlay`)
  const placeholder = el.querySelector(`.${prefix}placeholder-image`)
  const hideControls = false // can be used later for e.g. hero videos
  let initialized = false
  let player

  if (consentPreview) {
    el.classList.add(`${prefix}is--consent-preview`)
  }

  const initApi = () => {
    el.classList.add(`${prefix}is--loading`)

    const initPlayer = () => {
      const dimensions = { width: placeholder.offsetWidth, height: placeholder.offsetHeight }

      player = new YT.Player(videoContainer, {
        width: dimensions.width,
        height: dimensions.height,
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          controls: hideControls ? 0 : 1,
          showinfo: 0,
          modestbranding: 1,
          loop: 1
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      })
    }

    if ((typeof YT) !== 'undefined') {
      initPlayer()
    } else {
      const tag = document.createElement('script')
      tag.src = 'https://www.youtube.com/iframe_api'
      const firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

      window.onYouTubeIframeAPIReady = () => {
        initPlayer()
      }
    }
  }

  overlay.addEventListener('click', () => {
    if (initialized) {
      player.playVideo()
    } else {
      initApi()
    }
  })

  const onPlayerReady = (event) => {
    initialized = true
    player.setPlaybackQuality('highres')
    el.classList.remove(`${prefix}is--mounted`)
    el.classList.remove(`${prefix}is--loading`)
    el.classList.add(`${prefix}is--playing`)
    player.playVideo()
  }

  const onPlayerStateChange = (event) => {
    if (initialized && hideControls) {
      if (event.data === YT.PlayerState.PLAYING) {
        el.classList.add(`${prefix}is--playing`)
      } else if (event.data === YT.PlayerState.ENDED) {
        player.playVideo()
      } else {
        el.classList.remove(`${prefix}is--playing`)
      }
    }
  }
}

register('CorporateYoutubeVideo', CorporateYoutubeVideo, null, CorporateYoutubeVideo, 'BJz7qNsdj-7')
